"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_react_1 = require("mobx-react");

var react_1 = require("react");

var PantSessio = function PantSessio(props) {
  var sessState = props.appState.sessState;
  var pantState = props.appState.pantState;
  react_1.useEffect(function () {
    var sescod = props.match.params.sescod;
    sessState.loginBySescod(sescod).then(function () {
      var from = '/' + props.location.pathname.split('/').slice(3).join('/');
      pantState.replacePantalla(from);
    });
  }, []); // if (sessState.esLoginat && sessState.tePermis) {
  //     const from = '/' + props.location.pathname.split('/').slice(3).join('/');
  //     return <Redirect to={from}/>;
  // }

  return null;
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(PantSessio));